define(function(require,exports,module){"use strict";module.name="widget-hdfc-back-to-top";var base=require("base"),core=require("core"),ui=require("ui"),deps=[core.name,ui.name];module.exports=base.createModule(module.name,deps).controller(require("./controllers")).constant("WIDGET_NAME",module.name).run(function(){})});


// WEBPACK FOOTER //
// ./src/widget-hdfc-back-to-top/scripts/index.js